import * as React from 'react';
import { styled } from '@linaria/react';

import usePrefersReducedMotion from '@/hooks/use-prefers-reduced-motion';

import Demo from '@/components/Demo';

import CheckmarkButton from './CheckmarkButton';

function OscillationAmountDemo() {
  const [isPlaying, setIsPlaying] = React.useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  React.useEffect(() => {
    setIsPlaying(!prefersReducedMotion);
  }, [prefersReducedMotion]);

  return (
    <Demo initialValues={{}} outputWrapper={null}>
      {() => {
        return (
          <Wrapper>
            <BallWrapper>
              <BallSocket />
              <BallElem
                style={{
                  animationPlayState: isPlaying
                    ? 'running'
                    : 'paused',
                  '--oscillation-amount': '8px',
                }}
              />
            </BallWrapper>
            <BallWrapper>
              <BallSocket />
              <BallElem
                style={{
                  animationPlayState: isPlaying
                    ? 'running'
                    : 'paused',
                  '--oscillation-amount': '16px',
                }}
              />
            </BallWrapper>
            <BallWrapper>
              <BallSocket />
              <BallElem
                style={{
                  animationPlayState: isPlaying
                    ? 'running'
                    : 'paused',
                  '--oscillation-amount': '32px',
                }}
              />
            </BallWrapper>
            <BallWrapper>
              <BallSocket />
              <BallElem
                style={{
                  animationPlayState: isPlaying
                    ? 'running'
                    : 'paused',
                  '--oscillation-amount': '64px',
                }}
              />
            </BallWrapper>
            <Button
              isToggled={isPlaying}
              onClick={() => setIsPlaying(!isPlaying)}
            >
              Play animation
            </Button>
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const BallWrapper = styled.div`
  position: relative;
`;

const BallSocket = styled.div`
  position: absolute;
  inset: 0;
  border: 2px solid var(--color-gray-300);
  border-radius: 45%;
  background: url('/images/partial-keyframes/transparent-white-16x16-10p.png')
    repeat;
`;

const BallElem = styled.div`
  --size: 48px;
  position: relative;
  background: hsl(50deg 100% 50%);
  border-radius: 45%;
  width: var(--size);
  height: var(--size);

  @keyframes oscillate {
    from {
      transform: translateX(calc(var(--oscillation-amount) * -1));
    }
    to {
      transform: translateX(var(--oscillation-amount));
    }
  }

  animation: oscillate 500ms ease-in-out infinite alternate;
`;

const Button = styled(CheckmarkButton)`
  margin-top: 16px;
`;

export default OscillationAmountDemo;
